var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"component-fade"}},[_c('b-icon',{attrs:{"icon":"three-dots","animation":"cylon","font-scale":"4"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }